// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FaFa","rootNoMargin":"styles_rootNoMargin__32Wrp"};